<p style="text-align: center">
  Здесь когда то чтото будет ))
  <br />
  Dashboard
</p>
